module.exports = __webpack_public_path__ + "static/img/105_TO8_1788.2f2c002.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/105_TO8_1788.jpg
// module id = kOlT
// module chunks = 0